
import * as React from "react";
import { ChevronRight } from "lucide-react";
import {
  Collapsible,
  CollapsibleContent,
  CollapsibleTrigger,
} from "@/components/ui/collapsible";
import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
} from "@/components/ui/sidebar";
import { CollapsibleNavMainItem } from "./CollapsibleNavMainItem";

interface NavMainProps {
  items: {
    title: string;
    url: string;
    icon?: React.ElementType;
    isActive?: boolean;
    defaultOpen?: boolean;
    onClick?: (e: React.MouseEvent) => void | Promise<void>;
    items?: {
      title: string;
      url: string;
      isActive?: boolean;
      onClick?: (e: React.MouseEvent) => void | Promise<void>;
    }[];
  }[];
  onNavigate: (path: string) => void;
}

export function NavMain({ items, onNavigate }: NavMainProps) {
  const [openStates, setOpenStates] = React.useState<Record<string, boolean>>(() => {
    const initialStates: Record<string, boolean> = {};
    items.forEach((item) => {
      if (item.items) {
        initialStates[item.title] = item.defaultOpen || item.title === "Portfolios" || item.title === "Investments";
      }
    });
    return initialStates;
  });

  const toggleOpen = (title: string) => {
    setOpenStates(prev => ({ ...prev, [title]: !prev[title] }));
  };

  return (
    <SidebarMenu>
      {items.map((item, index) => (
        <SidebarMenuItem key={index}>
          {item.items ? (
            <CollapsibleNavMainItem
              item={item}
              isOpen={openStates[item.title]}
              onToggle={() => toggleOpen(item.title)}
              onNavigate={onNavigate}
            />
          ) : (
            <SidebarMenuButton
              isActive={item.isActive}
              tooltip={item.title}
              aria-label={item.title}
              className="w-full justify-start pl-4 group-data-[collapsible=icon]:justify-center group-data-[collapsible=icon]:mx-auto group-data-[collapsible=icon]:!pl-2"
              onClick={(e) => {
                e.preventDefault();
                if (item.onClick) {
                  item.onClick(e);
                } else if (item.url !== '#') {
                  onNavigate(item.url);
                }
              }}
            >
              {item.icon && <item.icon className="h-4 w-4" />}
              <span className="group-data-[collapsible=icon]:hidden truncate">{item.title}</span>
            </SidebarMenuButton>
          )}
        </SidebarMenuItem>
      ))}
    </SidebarMenu>
  );
}
